'use strict';

var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');
var _ = require('underscore');

var polyglot = require('../utilities/polyglot').default;

var ButtonView = require('./buttons/button').default;

export default Marionette.View.extend({

  tagName: 'form',
  masks: {},

  constructor: function (options) {
    Marionette.View.apply(this, arguments);
  },

  initializeSubmit: function () {
    if (!this.submit) {
      return;
    }

    var submit = (typeof this.submit === 'function') ? this.submit() : this.submit;
    if (!submit) {
      return;
    }

    if (typeof submit == 'string') {
      submit = {text: submit};
    }

    this.submitView = new ButtonView(submit);
    this.listenTo(this.submitView, 'click', this.onSubmit);
  },

  isValid: function () {
    return this.model.isValid({step: Radio.channel('steps').request('current').get('slug')});
  },

  isMainAttendeeDuplicate: function () {
    if (!this.model.has('additionalClients')) {
      return false;
    }

    const client = this.model.get('client')[0];
    const duplicates = this.model.get('additionalClients').filter(additionalClient => (
        additionalClient.get('first_name').toLowerCase() === client.first_name.toLowerCase()
        && additionalClient.get('last_name').toLowerCase() === client.last_name.toLowerCase()
        && additionalClient.get('email').toLowerCase() === client.email.toLowerCase()
    ));

    return duplicates.length > 0;
  },

  onRender: function () {
    this.showFields();
    this.applyMasks();

    this.initializeSubmit();
    this.initializeCountrySelect();
    this.initializeAttendeesList();

    if (this.getRegion('buttons') && this.submitView) {
      this.getRegion('buttons').show(this.submitView);
    }

    if (typeof this.renderIntlTelInputs === 'function') {
      this.renderIntlTelInputs();
    }
  },

  showFields: function () {},

  initializeCountrySelect: function () {},

  initializeAttendeesList: function () {},

  onKeyUp: function () {
    this.updateModel();
    this.trigger('change');
  },

  onCountryChange: function () {
    this.resetProvinceState();
    this.updateModel();
    this.trigger('change');
  },

  onAddressKeyUp: function () {
    this.autoFillAwayLocation();
    this.updateModel();
    this.trigger('change');
  },

  onNext: function () {
    this.updateModel();
    this.trigger('change');

    this.hideErrors();
    Radio.channel('buttons').request('next:disable');

    if (!this.isValid()) {
      this.showErrors();
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('forms.error'),
        iconColor: 'error',
      });
    }

    const step = Radio.channel('steps').request('current').get('slug');
    if (step === 'details' && this.isMainAttendeeDuplicate()) {
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('forms.attendees.duplicate'),
        iconColor: 'error',
      });

      Radio.channel('details').reply('duplicate', true);

      return;
    }

    Radio.channel('buttons').request('next:enable');
    this.trigger('next', this.model);
  },

  onSubmit: function () {
    this.updateModel();
    this.trigger('change');
    this.hideErrors();

    if (this.isValid()) {
      const step = Radio.channel('steps').request('current').get('slug');
      if (step === 'details' && this.isMainAttendeeDuplicate()) {
        Radio.channel('toast').trigger('show', {
          message: polyglot.t('forms.attendees.duplicate'),
          iconColor: 'error',
        });

        return;
      }

      this.disableSubmit();
      this.trigger('submit', this.model);
    } else {
      this.showErrors();
      Radio.channel('toast').trigger('show', {
        message: polyglot.t('forms.error'),
        iconColor: 'error'
      });
    }
  },

  applyMasks: function () {
    _.each(this.masks, _.bind(this.applyMask, this));
  },

  applyMask: function (mask, name) {
    this.ui[name].mask(mask);
  },

  showErrors: function () {
    _.each(this.model.validationError, _.bind(this.showError, this));
  },

  showError: function (error, field) {
    if (this.ui[field]) {
      this.ui[field].addClass('invalid');
      this.ui[field].after('<div class="form-error">' + error + '</div>');
    } else {
      var el = this.$('#' + field);
      if (el && el.length) {
        el.addClass('invalid');
        el.after('<div class="form-error">' + error + '</div>');
      }
    }
  },

  hideErrors: function () {
    this.$('.invalid').removeClass('invalid');
    this.$('.form-error').remove();
  },

  enableSubmit: function () {
    Radio.channel('buttons').request('book:enable');

    if (this.submitView) {
      this.submitView.enable();
    }
  },

  disableSubmit: function () {
    Radio.channel('buttons').request('book:disable');

    if (this.submitView) {
      this.submitView.disable();
    }
  },

});
